import { ChangeDetectorRef, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import { Empresa } from 'src/app/models/configuracion/empresa.model';
import { GrupoAcceso } from 'src/app/models/seguridad/grupo_acceso.model';
import { ProcesoReporte } from 'src/app/pages/base/proceso-reporte';
import { EmpresaService } from 'src/app/services/configuracion/empresa.service';
import { ContactoService } from 'src/app/services/notificacion/contacto.service';
import { HistorialNotificacionService } from 'src/app/services/notificacion/historial_notificacion.service';
import { JobService } from 'src/app/services/notificacion/job.service';
import { Global } from 'src/global';

@Component({
    selector: 'app-enviar-correo',
    templateUrl: './enviar-correo.component.html',
    styleUrls: ['./enviar-correo.component.scss']
})
export class EnviarCorreoComponent extends ProcesoReporte implements OnInit {

    uploadedFiles: any[] = [];
    selectFiles: any[] = [];
    isMobile: boolean;
    contactos: any[] = []; 
    timer: any;
    contactosSeleccionados:  any[] = []; 
    @ViewChild('textareaRef') textareaRef: ElementRef;
    cols: number = 120; 
    tipoCooperativa = Empresa.COOPERATIVA;
    grupoAcceso: GrupoAcceso;
    moduloTarjeta: boolean;

    // Tipos de origen - SOLO 2 opciones: Contactos (BD) o Excel
    tiposOrigen = [
        { valor: 'contactos', nombre: 'Lista de Contactos', descripcion: 'Elegir de mi base de datos', icono: 'pi pi-database' },
        { valor: 'excel', nombre: 'Archivo Excel/CSV', descripcion: 'Subir archivo con destinatarios', icono: 'pi pi-file-excel' }
    ];
    origenSeleccionado: string = 'contactos';

    // Variables para Excel
    excelData: any[] = [];
    excelPreview: any[] = [];
    excelStats = { total: 0, validos: 0, invalidos: 0 };
    archivoExcelSubido: boolean = false;
    cargaMasivaId: number | null = null;

    // Guardar todos los contactos originales
    private todosLosContactos: any[] = [];

    // Variables para progreso del job
    jobId: number | null = null;
    jobStatus: any = null;
    mostrarProgreso: boolean = false;
    intervaloProgreso: any = null;

    contactosMedalla = [
        { valor: 1, nombre: 'Cabal'},
        { valor: 2, nombre: 'Procard'},
        { valor: 3, nombre: 'Cabal y Procard' },
        { valor: 4, nombre: 'Otros' },
        { valor: 5, nombre: 'Todos' }
    ]
    constructor(
        private fb: FormBuilder,
        private contactoService: ContactoService,
        public messageService: MessageService,
        private router: Router,
        private breadcrumbService: AppBreadcrumbService,
        private empresaService: EmpresaService,
        private notificacion: HistorialNotificacionService,
        private jobService: JobService,
        private cdr: ChangeDetectorRef

    ) { 
        super();
        this.breadcrumbService.setItems([ { label: 'Notificacion'},{ label: 'Enviar Correo' } ]);
        this.isMobile = window.innerWidth <= 768; 

    }

    ngOnInit(): void {
        this.crearFormulario();
        this.permisos();
        this.cargarContactos();
    }

    async cargarContactos() {
        try {
            const idEmpresa = this.currentUser?.id_empresa || this.formGroup?.value?.id_empresa;
            
            if (!idEmpresa) return;
            
            // Usar el endpoint de filtrar contacto - filtro vacío para traer todos
            const body = {
                id_empresa: idEmpresa,
                filtro_contacto: '',  // vacío = traer todos (el backend lo convierte a '*')
                cooperativa: this.currentUser?.empresa?.tipo === this.tipoCooperativa,
                contactos_medalla: this.formGroup?.value?.contactos_medalla || 3,
                tipo_busqueda: 'correo'  // Para correos, buscar por correo
            };
            
            const res = await this.contactoService.filtarContacto(body);
            
            if (res.ok && res.resp && res.resp.length > 0) {
                // El backend ya filtra los que tienen correo
                // Aplanar el array de arrays
                const todosLosContactos = res.resp.flat();
                
                // Crear opciones con nombre y correo
                this.contactos = todosLosContactos.map((contacto: any) => {
                    const correo = contacto.correo || '';
                    const nombre = contacto.nombre || '';
                    // Mostrar "nombre - correo" para identificar mejor
                    const label = nombre ? `${nombre} - ${correo}` : correo;
                    
                    return {
                        ...contacto,
                        label: label,
                        correo: correo,  // Necesario para optionValue
                        description: nombre
                    };
                });
                
                console.log('Contactos cargados para correo:', this.contactos.length);
            } else {
                this.contactos = [];
                console.log('No se encontraron contactos con correo');
            }
        } catch (error) {
            console.error('Error cargando contactos:', error);
            this.contactos = [];
        }
    }

    /**
     * Cuando cambia el tipo de tarjeta (Cabal, Procard, etc)
     */
    async onTipoTarjetaChange() {
        this.contactosSeleccionados = [];
        await this.cargarContactos();
    }

    ngOnDestroy(): void {
        if (this.intervaloProgreso) {
            clearInterval(this.intervaloProgreso);
        }
    }

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        this.isMobile = event.target.innerWidth <= 768;
    }

    ngAfterViewInit() {
        this.calculateCols();
    }

    async permisos() {
        this.grupoAcceso = new GrupoAcceso();
        await this.grupoAcceso.cargarObjeto(this.currentUser.grupo_acceso);
        for (let index = 0; index < this.grupoAcceso.modulos.length; index++) {
            const acceso = this.grupoAcceso.modulos[index];            
            switch (acceso.codigo) {
                case 'cliente_tarjeta':
                    this.moduloTarjeta = acceso.activo;
                    break;
                default:
                    break;
            }
        }
        if (!this.moduloTarjeta) {
            this.contactosMedalla = [
                { valor: 4, nombre: 'Otros' }
            ];
            this.formGroup.get('contactos_medalla').setValue(4);
        }
    }

    async crearFormulario() {
        // Obtener valores de forma segura
        const idEmpresa = this.currentUser?.id_empresa || 0;
        const nombreEmpresa = this.currentUser?.nombre_empresa || '';
        
        this.formGroup = this.fb.group({
            id_empresa: [idEmpresa],
            nombre_empresa: [nombreEmpresa],
            id_creado_por: [this.currentUser?.id],
            nombre: [null],
            descripcion: [null],
            imagenes: [null],
            contactosSeleccionados:[null],
            contactos_medalla: [3],
            fecha: [new Date()],
            activo: [true],
            tipo: [3],
            origen: ['contactos'],
        })
    }

    //configuracion del texto 
    calculateCols() {
        if (!this.textareaRef?.nativeElement) return;
        
        const textareaWidth = this.textareaRef.nativeElement.offsetWidth;
        const maxWidth = 400; 
        const minWidth = 200; 
        const minCols = 20; 
        const maxCols = 120;
        this.cols = Math.max( minCols, Math.min(maxCols, Math.floor(textareaWidth / maxWidth * maxCols)));
        this.cdr.detectChanges();
    }

    /**
     * Cambio de origen - solo 2 opciones: contactos o excel
     */
    async onOrigenChange() {
        const origen = this.formGroup.get('origen')?.value;
        this.origenSeleccionado = origen;
        
        if (origen === 'excel') {
            // Limpiar contactos cuando selecciona excel
            this.contactos = [];
            this.contactosSeleccionados = [];
        } else {
            // contactos - limpiar excel
            this.excelData = [];
            this.excelPreview = [];
            this.excelStats = { total: 0, validos: 0, invalidos: 0 };
            this.archivoExcelSubido = false;
            this.cargaMasivaId = null;
            // Recargar contactos
            await this.cargarContactos();
        }
    }

    /**
     * Manejar archivo Excel subido
     */
    async onExcelSelect(event: any) {
        try {
            const selectedFile = event.files[0];
            if (!selectedFile) return;

            const base64 = await this.blobToBase64(selectedFile);
            
            const body = {
                id_empresa: this.currentUser.id_empresa,
                nombre_empresa: this.currentUser.nombre_empresa,
                archivo_base64: base64,
                nombre_archivo: selectedFile.name,
                id_creado_por: this.currentUser.id
            };

            this.loading = true;
            const resp = await this.notificacion.subirArchivoExcel(body);
            this.loading = false;

            if (resp.ok) {
                this.excelData = resp.resp.contactos || [];
                this.excelStats = {
                    total: resp.resp.total,
                    validos: resp.resp.validos,
                    invalidos: resp.resp.invalidos
                };
                this.excelPreview = resp.resp.preview || [];
                this.cargaMasivaId = resp.resp.carga_id;
                this.archivoExcelSubido = true;

                // Convertir a formato de contactos - SOLO los que tienen correo
                this.contactos = this.excelData
                    .filter((c: any) => c.correo)  // Solo los que tienen correo
                    .map((c: any) => {
                        const correo = c.correo || '';
                        const nombre = c.nombre || '';
                        const label = nombre ? `${nombre} - ${correo}` : correo;
                        
                        return {
                            ...c,
                            label: label,
                            correo: correo,
                            description: nombre
                        };
                    });

                this.messageService.add({
                    severity: 'success',
                    summary: 'Archivo cargado',
                    detail: `${this.excelStats.validos} contactos con correo de ${this.excelStats.total} total`
                });
            } else {
                // El archivo no tiene columna de correo
                this.messageService.add({
                    severity: 'error',
                    summary: 'Error en archivo',
                    detail: resp.msg || 'El archivo debe tener una columna de correo'
                });
                this.onExcelClear();
            }

        } catch (error: any) {
            this.loading = false;
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: error.message || 'Error al procesar archivo'
            });
        }
    }

    /**
     * Limpiar archivo Excel
     */
    onExcelClear() {
        this.excelData = [];
        this.excelPreview = [];
        this.excelStats = { total: 0, validos: 0, invalidos: 0 };
        this.archivoExcelSubido = false;
        this.cargaMasivaId = null;
        this.contactos = [];
    }

    /**
     * Iniciar polling de progreso del job
     */
    private iniciarProgresoJob(jobId: number) {
        this.jobId = jobId;
        this.mostrarProgreso = true;
        this.jobStatus = { estado: 'pendiente', procesados: 0, total_registros: 0, porcentaje: 0 };

        this.intervaloProgreso = setInterval(async () => {
            try {
                const resp = await this.jobService.getStatus(jobId, this.currentUser.id_empresa);
                if (resp.ok) {
                    this.jobStatus = resp.resp;
                    this.cdr.detectChanges();

                    if (this.jobStatus.estado === 'completado' || this.jobStatus.estado === 'fallido') {
                        clearInterval(this.intervaloProgreso);
                        
                        if (this.jobStatus.estado === 'completado') {
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Envío completado',
                                detail: `${this.jobStatus.procesados} correos enviados`
                            });
                        } else {
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Envío fallido',
                                detail: this.jobStatus.error_mensaje || 'Error en el procesamiento'
                            });
                        }
                    }
                }
            } catch (error) {
                console.error('Error consultando estado del job:', error);
            }
        }, 5000);
    }

    async onEmpresa() {
        try {
            const value = this.formGroup.value;  
            let objeto = null;
            const filtros = [
                { field: 'id', value: value.id_empresa, type: 'id' },
            ]
            const res = await this.empresaService.getAll( Global.SIZE_GET_ALL, { filters: filtros } );
            if ( res.ok && res.resp.count > 0 ) {
                objeto = res.resp.rows[0];
            } else {
                this.messageService.add({severity: 'info', summary: 'Empresa no encontrada', detail: ''});
            }
            await this.setEmpresa(objeto);
        } catch (error: any) {
            this.messageService.add(this.objSession);
            setTimeout( () => { this.router.navigate(this.routerLogout) }, 4000);
        }
    }


    async setEmpresa( obj: Record<string, any> ) {
        this.formGroup.get('id_empresa').setValue(obj?.id);
        this.formGroup.get('nombre_empresa').setValue(obj?.nombre);
    }


    async cerrarOnLista( obj?: Record<string, any> ): Promise<void> {
        await super.cerrarOnLista( obj );
        if ( this.objClassOnLista === Empresa && obj ) {
            await this.setEmpresa(obj);
        }
        this.objClassOnLista = null;
    }
    
    async onListaEmpresa() {
        await super.onLista( this.empresaService, Empresa, Empresa.NOMBRE_PLURAL );
    }

    async onSelect(event: any) {
        const selectedFiles = event.files;
        const file = [];
        file.push(selectedFiles[0])        
        const files = [];
        this.selectFiles = file;
        
        for (let selectedFile of selectedFiles) {
            const file = await this.blobToBase64(selectedFile);
            files.push(file);
        }
        this.uploadedFiles = files;
    }
    
    async blobToBase64(blob: Blob): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64String = reader.result as string;
                resolve(base64String.split(',')[1]); 
            };
            reader.onerror = () => {
                reject('Error al leer el archivo');
            };
            reader.readAsDataURL(blob);
        });
    }
    

    async onRemove(event: any) {
        const removedFileName = event.file.name;        
        this.uploadedFiles = this.uploadedFiles.filter((file: any) => file.name !== removedFileName);        
        this.selectFiles = this.selectFiles.filter((file: any) => file.name !== removedFileName);        
    }
    
    
    async onFilter(event: any) {
        this.cdr.detectChanges();        
        let cooperativa = false;
        const contactos_medalla = this.formGroup.value.contactos_medalla;
        const contactoSelecionado = this.formGroup.value.contactosSeleccionados || [];
        const filterValue = event.filter; 
        
        // Si hay filtro, buscar en el backend
        if (filterValue) {
            const filtros = { 
                id_empresa: this.formGroup.value.id_empresa, 
                filtro_contacto: filterValue,
                tipo_busqueda: 'correo'
            };
            if (this.currentUser.empresa.tipo === this.tipoCooperativa) {
                cooperativa = true;
                filtros['contactos_medalla'] = contactos_medalla;
            }
            filtros['cooperativa'] = cooperativa;
            
            const resp = await this.contactoService.filtarContacto(filtros);         
            
            if (resp.ok && resp.resp && resp.resp.length > 0) {
                const nuevosContactos = resp.resp.flat().map((contacto: any) => {
                    const correo = contacto.correo || '';
                    const nombre = contacto.nombre || '';
                    const label = nombre ? `${nombre} - ${correo}` : correo;
                    return {
                        ...contacto,
                        label: label,
                        correo: correo
                    };
                });
                
                // Mantener seleccionados + filtrar duplicados
                const elementosFiltrados = nuevosContactos.filter((elemento: any) => {
                    return !contactoSelecionado.some((c: any) => c.correo === elemento.correo);
                });
                
                // Crear objetos para los seleccionados (del form vienen como objetos)
                const seleccionados = contactoSelecionado.map((c: any) => {
                    const correo = typeof c === 'string' ? c : (c.correo || c);
                    const nombre = c.nombre || '';
                    const label = nombre ? `${nombre} - ${correo}` : correo;
                    return { correo, label, nombre };
                });
                
                this.contactos = [...seleccionados, ...elementosFiltrados];
            }
        } else {
            // Sin filtro, cargar todos
            const body = {
                id_empresa: this.currentUser?.id_empresa,
                filtro_contacto: '',
                cooperativa: this.currentUser?.empresa?.tipo === this.tipoCooperativa,
                contactos_medalla: this.formGroup?.value?.contactos_medalla || 3,
                tipo_busqueda: 'correo'
            };
            
            const res = await this.contactoService.filtarContacto(body);
            
            if (res.ok && res.resp && res.resp.length > 0) {
                const todosLos = res.resp.flat();
                this.todosLosContactos = todosLos.map((contacto: any) => {
                    const correo = contacto.correo || '';
                    const nombre = contacto.nombre || '';
                    const label = nombre ? `${nombre} - ${correo}` : correo;
                    return {
                        ...contacto,
                        label: label,
                        correo: correo
                    };
                });
                
                // Mantener los seleccionados + el resto
                const seleccionados = contactoSelecionado.map((c: any) => {
                    const correo = typeof c === 'string' ? c : (c.correo || c);
                    const nombre = c.nombre || '';
                    const label = nombre ? `${nombre} - ${correo}` : correo;
                    return { correo, label, nombre };
                });
                
                const sinSeleccionar = this.todosLosContactos.filter(
                    (elemento: any) => !contactoSelecionado.some((c: any) => c.correo === elemento.correo)
                );
                
                this.contactos = [...seleccionados, ...sinSeleccionar];
            }
        }
        
        this.cdr.detectChanges(); 
    }
         
    async enviar() {
        try {
            const value = this.formGroup.getRawValue();
            let origen = value.origen;

            // Si hay contactos seleccionados, el origen es "seleccion"
            if (this.contactosSeleccionados && this.contactosSeleccionados.length > 0) {
                origen = 'seleccion';
            }

            // Validaciones según origen
            if (origen === 'excel' && !this.archivoExcelSubido) {
                this.messageService.add({severity: 'error', summary: 'Archivo requerido', detail: 'Suba un archivo Excel/CSV'});
                return;
            }

            // El origen 'seleccion' ya no requiere validar que haya seleccionados (ya sabemos que los hay por la lógica de arriba)
            
            value.imagenes = this.uploadedFiles[0];
            if ( this.selectFiles.length === 0 ) {
                this.messageService.add({severity: 'error', summary: 'Formulario Inválido', detail: 'Agregue  al menos una imagen'});            
                return
            }
            if ( !value.nombre ) {
                this.messageService.add({severity: 'error', summary: 'Formulario Inválido', detail: 'Agregue  un titulo'});            
                return
            }
            
            this.loading = true;
            value['tipo_empresa'] =  this.currentUser.empresa.tipo;
            value['origen'] = origen;
            
            // Configurar destinatarios según origen
            if (origen === 'seleccion') {
                value['contactosSeleccionados'] = this.contactosSeleccionados;
            } else if (origen === 'excel') {
                value['excelContactos'] = this.excelData;
            }

            // Guardar historial
            const guardar = await this.notificacion.guardarHistorialdeCorreo(value);  
            value['id_historial_correo'] = guardar.resp.id;

            // Crear job para procesamiento asíncrono
            // Tomar los contactos del form (ahí están los valores seleccionados del multiselect)
            const value2 = this.formGroup.getRawValue();
            const contactosDelForm = value2.contactosSeleccionados || [];
            
            console.log('contactosSeleccionados (propiedad):', this.contactosSeleccionados);
            console.log('contactosSeleccionados (form):', contactosDelForm);
            
            // Preferir los del form, si no están, usar los de la propiedad
            const destinatariosSeleccion = (contactosDelForm.length > 0 
                ? contactosDelForm 
                : (this.contactosSeleccionados || []))
                .map((c: any) => c.correo || c);
            
            console.log('destinatariosSeleccion:', destinatariosSeleccion);
            
            const jobBody = {
                tipo: 'email',
                tipo_origen: origen,
                id_empresa: value.id_empresa,
                nombre_empresa: value.nombre_empresa,
                id_creado_por: this.currentUser.id,
                nombre: value.nombre,
                total_registros: origen === 'excel' ? this.excelStats.validos : 
                                 origen === 'seleccion' ? destinatariosSeleccion.length : 0,
                parametros: {
                    id_historial_correo: guardar.resp.id,
                    mensaje: value.descripcion,
                    origen: origen,
                    carga_masiva_id: this.cargaMasivaId,
                    destinatarios: destinatariosSeleccion,
                    contactos_medalla: value.contactos_medalla,
                    tipo_empresa: value.tipo_empresa
                }
            };

            const jobResp = await this.jobService.crearJob(jobBody);
            
            if (jobResp.ok) {
                this.iniciarProgresoJob(jobResp.resp.id);
                
                this.messageService.add({
                    severity: 'success', 
                    summary: 'Proceso iniciado', 
                    detail: `Job #${jobResp.resp.id} creado. Puede ver el progreso abajo.`
                });
            } else {
                this.messageService.add({severity: 'error', summary: 'Error', detail: jobResp.msg});
            }

            this.loading = false;
        } catch (error) {
            this.loading = false;
            this.messageService.add({severity: 'error', summary: 'Error', detail: error.message, life: 6000 });
        }        
    }
}
